/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "кечээ",
        "-2": "мурдагы күнү",
        "0": "бүгүн",
        "1": "эртең",
        "2": "бүрсүгүнү",
        "future": {
          "one": "{0} күндөн кийин",
          "other": "{0} күндөн кийин"
        },
        "past": {
          "one": "{0} күн мурун",
          "other": "{0} күн мурун"
        }
      },
      "day-narrow": {
        "-1": "кечээ",
        "-2": "мурдагы күнү",
        "0": "бүгүн",
        "1": "эртең",
        "2": "бүрсүгүнү",
        "future": {
          "one": "{0} күн. кийин",
          "other": "{0} күн. кийин"
        },
        "past": {
          "one": "{0} күн мурун",
          "other": "{0} күн мурун"
        }
      },
      "day-short": {
        "-1": "кечээ",
        "-2": "мурдагы күнү",
        "0": "бүгүн",
        "1": "эртең",
        "2": "бүрсүгүнү",
        "future": {
          "one": "{0} күн. кийин",
          "other": "{0} күн. кийин"
        },
        "past": {
          "one": "{0} күн мурун",
          "other": "{0} күн мурун"
        }
      },
      "hour": {
        "0": "ушул саатта",
        "future": {
          "one": "{0} сааттан кийин",
          "other": "{0} сааттан кийин"
        },
        "past": {
          "one": "{0} саат мурун",
          "other": "{0} саат мурун"
        }
      },
      "hour-narrow": {
        "0": "ушул саатта",
        "future": {
          "one": "{0} с. кийн",
          "other": "{0} с. кийн"
        },
        "past": {
          "one": "{0} с. мурн",
          "other": "{0} с. мурн"
        }
      },
      "hour-short": {
        "0": "ушул саатта",
        "future": {
          "one": "{0} саат. кийин",
          "other": "{0} саат. кийин"
        },
        "past": {
          "one": "{0} саат. мурун",
          "other": "{0} саат. мурун"
        }
      },
      "minute": {
        "0": "ушул мүнөттө",
        "future": {
          "one": "{0} мүнөттөн кийин",
          "other": "{0} мүнөттөн кийин"
        },
        "past": {
          "one": "{0} мүнөт мурун",
          "other": "{0} мүнөт мурун"
        }
      },
      "minute-narrow": {
        "0": "ушул мүнөттө",
        "future": {
          "one": "{0} мүн. кийн",
          "other": "{0} мүн. кийн"
        },
        "past": {
          "one": "{0} мүн. мурн",
          "other": "{0} мүн. мурн"
        }
      },
      "minute-short": {
        "0": "ушул мүнөттө",
        "future": {
          "one": "{0} мүн. кийин",
          "other": "{0} мүн. кийин"
        },
        "past": {
          "one": "{0} мүн. мурун",
          "other": "{0} мүн. мурун"
        }
      },
      "month": {
        "-1": "өткөн айда",
        "0": "бул айда",
        "1": "эмдиги айда",
        "future": {
          "one": "{0} айдан кийин",
          "other": "{0} айдан кийин"
        },
        "past": {
          "one": "{0} ай мурун",
          "other": "{0} ай мурун"
        }
      },
      "month-narrow": {
        "-1": "өткөн айда",
        "0": "бул айда",
        "1": "эмдиги айда",
        "future": {
          "one": "{0} айд. кийн",
          "other": "{0} айд. кийн"
        },
        "past": {
          "one": "{0} ай мурн",
          "other": "{0} ай мурн"
        }
      },
      "month-short": {
        "-1": "өткөн айда",
        "0": "бул айда",
        "1": "эмдиги айда",
        "future": {
          "one": "{0} айд. кийин",
          "other": "{0} айд. кийин"
        },
        "past": {
          "one": "{0} ай мурун",
          "other": "{0} ай мурун"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "акыркы чейрек",
        "0": "бул чейрек",
        "1": "кийинки чейрек",
        "future": {
          "one": "{0} чейректен кийин",
          "other": "{0} чейректен кийин"
        },
        "past": {
          "one": "{0} чейрек мурун",
          "other": "{0} чейрек мурун"
        }
      },
      "quarter-narrow": {
        "-1": "акыркы чейр.",
        "0": "бул чейр.",
        "1": "кийинки чейр.",
        "future": {
          "one": "{0} чейр. кийин",
          "other": "{0} чейр. кийин"
        },
        "past": {
          "one": "{0} чейр. мурун",
          "other": "{0} чейр. мурун"
        }
      },
      "quarter-short": {
        "-1": "акыркы чейр.",
        "0": "бул чейр.",
        "1": "кийинки чейр.",
        "future": {
          "one": "{0} чейректен кийин",
          "other": "{0} чейректен кийин"
        },
        "past": {
          "one": "{0} чейр. мурун",
          "other": "{0} чейр. мурун"
        }
      },
      "second": {
        "0": "азыр",
        "future": {
          "one": "{0} секунддан кийин",
          "other": "{0} секунддан кийин"
        },
        "past": {
          "one": "{0} секунд мурун",
          "other": "{0} секунд мурун"
        }
      },
      "second-narrow": {
        "0": "азыр",
        "future": {
          "one": "{0} сек. кийн",
          "other": "{0} сек. кийн"
        },
        "past": {
          "one": "{0} сек. мурн",
          "other": "{0} сек. мурн"
        }
      },
      "second-short": {
        "0": "азыр",
        "future": {
          "one": "{0} сек. кийин",
          "other": "{0} сек. кийин"
        },
        "past": {
          "one": "{0} сек. мурун",
          "other": "{0} сек. мурун"
        }
      },
      "week": {
        "-1": "өткөн аптада",
        "0": "ушул аптада",
        "1": "келерки аптада",
        "future": {
          "one": "{0} аптадан кийин",
          "other": "{0} аптадан кийин"
        },
        "past": {
          "one": "{0} апта мурун",
          "other": "{0} апта мурун"
        }
      },
      "week-narrow": {
        "-1": "өткөн апт.",
        "0": "ушул апт.",
        "1": "келерки апт.",
        "future": {
          "one": "{0} апт. кийин",
          "other": "{0} апт. кийин"
        },
        "past": {
          "one": "{0} апт. мурун",
          "other": "{0} апт. мурун"
        }
      },
      "week-short": {
        "-1": "өткөн апт.",
        "0": "ушул апт.",
        "1": "келерки апт.",
        "future": {
          "one": "{0} апт. кийин",
          "other": "{0} апт. кийин"
        },
        "past": {
          "one": "{0} апт. мурун",
          "other": "{0} апт. мурун"
        }
      },
      "year": {
        "-1": "былтыр",
        "0": "быйыл",
        "1": "эмдиги жылы",
        "future": {
          "one": "{0} жылдан кийин",
          "other": "{0} жылдан кийин"
        },
        "past": {
          "one": "{0} жыл мурун",
          "other": "{0} жыл мурун"
        }
      },
      "year-narrow": {
        "-1": "былтыр",
        "0": "быйыл",
        "1": "эмдиги жылы",
        "future": {
          "one": "{0} жыл. кийин",
          "other": "{0} жыл. кийин"
        },
        "past": {
          "one": "{0} жыл мурун",
          "other": "{0} жыл мурун"
        }
      },
      "year-short": {
        "-1": "былтыр",
        "0": "быйыл",
        "1": "эмдиги жылы",
        "future": {
          "one": "{0} жыл. кийин",
          "other": "{0} жыл. кийин"
        },
        "past": {
          "one": "{0} жыл мурун",
          "other": "{0} жыл мурун"
        }
      }
    },
    "locale": "ky"
  });
}